/**
 * Funzioni di validazione centralizzate per i form dell'applicazione
 */

/**
 * Valida nome o cognome
 * - Minimo 2 caratteri
 * - Permette lettere (anche accentate), apostrofi e spazi
 */
export const validateName = (name: string, fieldName: string = 'Nome'): string => {
  const trimmedName = name.trim();

  if (trimmedName.length < 2) {
    return `${fieldName} deve contenere almeno 2 caratteri.`;
  }

  if (!/^[a-zA-ZÀ-ÖØ-öø-ÿ'\s]{2,}$/.test(trimmedName)) {
    return `${fieldName} può contenere solo lettere, apostrofi e spazi.`;
  }

  return '';
};

/**
 * Valida CAP italiano
 * - Esattamente 5 cifre numeriche
 */
export const validateCAP = (cap: string): string => {
  if (!/^[0-9]{5}$/.test(cap)) {
    return 'Il CAP deve essere composto da 5 cifre numeriche.';
  }

  return '';
};

/**
 * Valida numero di telefono italiano
 * - 10 cifre
 * - Deve iniziare con 3 (cellulari italiani)
 */
export const validateItalianPhone = (phone: string): string => {
  // Rimuove spazi, trattini e parentesi
  const cleanPhone = phone.replace(/[\s\-()]/g, '');

  if (!/^3[0-9]{9}$/.test(cleanPhone)) {
    return 'Il numero di telefono deve essere di 10 cifre e iniziare con 3.';
  }

  return '';
};

/**
 * Valida email
 */
export const validateEmail = (email: string): string => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    return 'Inserisci un indirizzo email valido.';
  }

  return '';
};
